<template>
  <el-dialog
    :title="type === 'xy' ? '录入线下协议' : '录入保单'"
    :visible.sync="dialogVisible"
    width="500px"
    :before-close="handleClose"
    @close="handleClose"
  >
    <el-form
      ref="agreementForm"
      :model="form"
      :rules="rules"
      label-width="150px"
      v-loading="loading"
    >
      <el-form-item label="生效时间：" prop="effectedAt">
        <el-date-picker
          v-model="form.effectedAt"
          type="date"
          placeholder="选择生效时间"
          value-format="yyyy-MM-dd"
          style="width: 100%"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="失效时间：" prop="expiredAt">
        <el-date-picker
          v-model="form.expiredAt"
          type="date"
          placeholder="选择失效时间"
          value-format="yyyy-MM-dd"
          style="width: 100%"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item v-if="type === 'bd'" label="大保单号：" prop="policyNo">
        <el-input
          v-model="form.policyNo"
          placeholder="请输入大保单号"
          maxlength="50"
        ></el-input>
      </el-form-item>

      <el-form-item v-if="type === 'xy'" label="协议文件：">
        <div v-if="!form.agreementUrl">
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            :headers="uploadHeaders"
            :on-success="handleAgreementUploadSuccess"
            :on-error="handleUploadError"
            :show-file-list="false"
            accept=".pdf,.jpg,.png,.jpeg"
            name="fileVal"
          >
            <el-button size="small" type="primary">上传</el-button>
          </el-upload>
        </div>
        <div v-else>
          <el-button size="small" @click="viewAgreement">查看</el-button>
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            :headers="uploadHeaders"
            :on-success="handleAgreementUploadSuccess"
            :on-error="handleUploadError"
            :show-file-list="false"
            accept=".pdf,.jpg,.png,.jpeg"
            name="fileVal"
            style="margin-left: 10px;"
          >
            <el-button size="small" type="primary">重新上传</el-button>
          </el-upload>
        </div>
      </el-form-item>

      <el-form-item v-if="type === 'bd'" label="电子保单：">
        <div v-if="!form.policyUrl">
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            :headers="uploadHeaders"
            :on-success="handlePolicyUploadSuccess"
            :on-error="handleUploadError"
            :show-file-list="false"
            accept=".pdf,.jpg,.png,.jpeg"
            name="fileVal"
          >
            <el-button size="small" type="primary">上传</el-button>
          </el-upload>
        </div>
        <div v-else>
          <el-button size="small" @click="viewPolicy">查看</el-button>
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            :headers="uploadHeaders"
            :on-success="handlePolicyUploadSuccess"
            :on-error="handleUploadError"
            :show-file-list="false"
            accept=".pdf,.jpg,.png,.jpeg"
            name="fileVal"
            style="margin-left: 10px;"
          >
            <el-button size="small" type="primary">重新上传</el-button>
          </el-upload>
        </div>
      </el-form-item>

      <el-form-item label="备注：" prop="note">
        <el-input
          v-model="form.note"
          placeholder="请输入备注"
          maxlength="50"
        ></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getSingleUserInfo, saveSingleUserPolicy } from '@/api/member'

export default {
  name: 'Agreement',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userId: {
      type: [String, Number],
      default: ''
    },
    type: {
      type: String,
      default: 'xy' // xy: 协议, bd: 保单
    }
  },
  data() {
    // 时间验证规则
    const validateDate = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请选择时间'))
        return
      }
      callback()
    }
    
    return {
      dialogVisible: this.visible,
      loading: false,
      submitting: false,
      form: {
        effectedAt: '',
        expiredAt: '',
        policyNo: '',
        agreementUrl: '',
        policyUrl: '',
        note: ''
      },
      rules: {
        effectedAt: [
          { required: true, validator: validateDate, trigger: 'change' }
        ],
        expiredAt: [
          { required: true, validator: validateDate, trigger: 'change' }
        ],
        policyNo: [
          { required: true, message: '请输入大保单号', trigger: 'blur' }
        ],
        note: [
          { required: true, message: '请输入备注', trigger: 'blur' }
        ]
      },
      uploadUrl: process.env.VUE_APP_FILE_UPLOAD_URL || 'http://test.rbbaotong.com/res/file/upload',
      uploadHeaders: {
        'Authorization': 'Bearer ' + (localStorage.getItem('jubao_admin_token') || localStorage.getItem('jubao_admin') || '')
      }
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        this.initData()
      }
    }
  },
  methods: {
    // 初始化数据
    async initData() {
      this.resetForm()
      
      // 获取用户信息
      if (this.userId) {
        try {
          const res = await getSingleUserInfo({ id: this.userId })
          if (res.err_code === 0) {
            // 这里应该根据实际返回的数据结构进行处理
            this.form.policyNo = res.data.policy_no
            this.form.note = res.data.note
            this.form.agreementUrl = res.data.agreement_url
            this.form.policyUrl = res.data.policy_url
            this.form.effectedAt = res.data.effected_at
            this.form.expiredAt = res.data.expired_at
          }
        } catch (error) {
          console.error('获取用户信息失败:', error)
        }
      }
    },

    // 重置表单
    resetForm() {
      this.$refs.agreementForm && this.$refs.agreementForm.resetFields()
      this.form = {
        effectedAt: '',
        expiredAt: '',
        policyNo: '',
        agreementUrl: '',
        policyUrl: '',
        note: ''
      }
    },

    // 协议文件上传成功回调
    handleAgreementUploadSuccess(response, file, fileList) {
      if (response.err_code === 0) {
        this.form.agreementUrl = response.data
        this.$message.success('上传成功')
      } else {
        this.$message.error(response.err_msg || '上传失败')
      }
    },

    // 保单文件上传成功回调
    handlePolicyUploadSuccess(response, file, fileList) {
      if (response.err_code === 0) {
        this.form.policyUrl = response.data
        this.$message.success('上传成功')
      } else {
        this.$message.error(response.err_msg || '上传失败')
      }
    },

    // 上传失败回调
    handleUploadError(err, file, fileList) {
      this.$message.error('上传失败')
    },

    // 查看协议文件
    viewAgreement() {
      if (this.form.agreementUrl) {
        window.open(this.form.agreementUrl, '_blank')
      }
    },

    // 查看保单文件
    viewPolicy() {
      if (this.form.policyUrl) {
        window.open(this.form.policyUrl, '_blank')
      }
    },

    // 关闭对话框
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },

    // 提交表单
    handleSubmit() {
      this.$refs.agreementForm.validate(async (valid) => {
        if (valid) {
          // 验证时间逻辑
          if (this.form.effectedAt && this.form.expiredAt) {
            const startTime = new Date(this.form.effectedAt).getTime()
            const endTime = new Date(this.form.expiredAt).getTime()
            if (startTime > endTime) {
              this.$message.warning('失效时间必须在生效时间之后')
              return
            }
          }
          
          // 根据类型验证必要文件
          if (this.type === 'xy' && !this.form.agreementUrl) {
            this.$message.warning('请上传协议文件')
            return
          }
          
          if (this.type === 'bd' && !this.form.policyUrl) {
            this.$message.warning('请上传电子保单')
            return
          }
          
          this.submitting = true
          try {
            const params = {
              user_id: Number(this.userId),
              effect_date: this.form.effectedAt ? new Date(this.form.effectedAt + ' 00:00:00').getTime() / 1000 : '',
              expire_date: this.form.expiredAt ? new Date(this.form.expiredAt + ' 23:59:59').getTime() / 1000 : '',
              note: this.form.note
            }
            
            // 根据类型添加特定参数
            if (this.type === 'bd') {
              params.policy_no = this.form.policyNo
              params.policy_url = this.form.policyUrl
            } else {
              params.agreement_url = this.form.agreementUrl
            }
            
            const res = await saveSingleUserPolicy(params)
            if (res.err_code === 0) {
              this.$message.success('保存成功')
              this.$emit('success')
              this.handleClose()
            } else if (res.err_code === 1002) {
              this.$message.error('没有操作权限')
            } else if (res.err_code === 1010) {
              this.$message.error('用户不存在')
            } else {
              this.$message.error(res.err_msg || '保存失败')
            }
          } catch (error) {
            console.error('保存失败:', error)
            this.$message.error('保存失败')
          } finally {
            this.submitting = false
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-footer {
  text-align: center;
}
</style>